import React from 'react'
import { Box, Text } from '@nike/eds'

export const Section = ({ title, children }) => {
  return (
    <Box className='token-site-card' mt='48px' maxWidth='1600px' minHeight='200px' minWidth='200px'>
      <div>
        {title && (
          <Text className='eds-spacing--mb-48' font='title-5'>
            {title}
          </Text>
        )}
        {children}
      </div>
    </Box>
  )
}
